import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import TableSkeleton from "@/shared/components/shared/TableSkeleton";
import { cn } from "@/shared/lib/utils";

export default function EntityTable({
  headers = [],
  data = [],
  isLoading = false,
  emptyMessage = "No items found",
  renderRow,
  skeletonRows = 5,
  skeletonColumns,
  className,
  containerClassName,
  minWidth = "900px",
}) {
  return (
    <div className={cn("bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden", containerClassName)}>
      <div className="overflow-x-auto scrollbar-thin">
        <Table className={cn("w-full", className)} style={{ minWidth }}>
          <TableHeader>
            <TableRow className="bg-slate-50/50 hover:bg-transparent border-b border-slate-100">
              {headers.map((header) => (
                <TableHead
                  key={header.id}
                  className={cn(
                    "font-bold text-slate-500 text-[11px] uppercase tracking-wider h-12 align-middle px-4",
                    header.className
                  )}
                >
                  {header.label}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading ? (
              <TableSkeleton columns={skeletonColumns || headers.length} rows={skeletonRows} />
            ) : data.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={headers.length}
                  className="text-center py-20 text-slate-400 font-medium bg-slate-50/20"
                >
                  <div className="flex flex-col items-center justify-center gap-2">
                    <p>{emptyMessage}</p>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, index) => renderRow(item, index))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
